const analyticsPageEvents = {
    ENTRY: "ENTRY",
    EVENT: "EVENT",
};

// GA Constants
const GaEvents = {
    GENERIC_EVENT: "event",
    PAGE_VIEW_EVENT: "logPageview",
};

const GaCategories = {
    API_RESPONSE: "Api_Response",
    EVOX: "Evox",
    APPOINTMENT: "Appointment",
    SERVICE_LOCATION: "service-location",
    CONFIRMATION_CLICKED: "confirmation clicked",
    INSHOP_CONFIRMATION_CLICKED: "inshop confirmation clicked",
    MOBILE_CONFIRMATION_CLICKED: "mobile confirmation clicked",
    RECAL_DISCLAIMER: "Recalibration disclaimer",
    VIN_ELIGIBLE: "VIN eligible",
    VIN_EDUCATION: "vin_education",
    MARKETING_CONSENT_MANAGEMENT: "MarketingConsentManagement",
    TIME_SELECTED: "time_selected",
    DATE_SELECTED: "date_selected",
    DATE_PICKER_NAVIGATION: "date_picker_navigation",
    METHOD_OF_SERVICE: "MethodOfService",
    MOS_SELECTION: "MOSSelection",
    PROVIDER_EXPANDED: "provider_expanded",
    MORE_LOCATIONS_CLICKED: "more_locations_clicked",
    MAP_LINK_CLICKED: "map_link_clicked",
    COVERAGE_STATEMENT: "coverage_statement",
    USER: "User",
    FILE_INSURANCE_CLAIM: "file_insurance_claim",
};

const GaActions = {
    RESULT: "Result",
    CLICKED: "Clicked",
    VIF: "vif",
    SUBMITTED: "Submitted",
    DISPLAYED: "Displayed",
    CASH_QUOTE_DISPLAYED: "Cash quote displayed",
    MOBILE_AVAILABLE: "mobile_available",
    SHOPS_FIRST_DISPLAYED: "shops_first_displayed",
    MORE_LOCATIONS_CLICKED: "more_locations_clicked",
    YES: "yes",
    NO: "no",
    TRUE: "true",
    FALSE: "false",
    ACKNOWLEDGED: "Acknowledged",
    CONFIRMED: "Confirmed",
    WITHDRAWN: "Withdrawn",
    COVERAGE_STATUS_UNVERIFIED: "coverage_status_unverified",
    COVERAGE_STATUS_VERIFIED: "coverage_status_verified",
    COVERAGE_VERIFIED_PAGE_TYPE: "coverage_verified_page_type",
    COVERAGE_VERIFIED: "Coverage Verified",
};

const GaLabels = {
    SUCCESS: "Success",
    ERROR: "Error",
    LICENSE_PLATE_LOOKUP: "License_Plate_Look_Up",
    VIN_LOOKUP: "Vin_Look_Up",
    ADDRESS_LOOKUP: "Address_Look_up",
    YES: "yes",
    NO: "no",
    GLASS_CASH_QUOTE: "GlassCashQuote",
    SAVE_PROGRESS: "Save Progress",
    QUOTE: "Quote",
    CUSTOMER_DETAILS: "Customer Details",
    EMAIL_ADDRESS: "EmailAddress",
    ERROR_SELECT_MOS: "ErrorSelectMOS",
    NO_CLAIM_AND_COVERAGE_CLIENT: "no_claim_and_coverage_client",
    YES_CLAIM_AND_COVERAGE_CLIENT: "yes_claim_and_coverage_client",
    DEDUCTIBLE_ONLY: "deductible_only",
    ITAC: "ITAC",
    NO_COMP: "no_comp",
    COVERAGE_NOT_VERIFIED: "Coverage not verified",
    COVERAGE_VERIFIED_YES: "Yes",
    COVERAGE_VERIFIED_NO: "No",
};

const ValueToLogTypes = {
    LAST_5: "last_5",
};

export { analyticsPageEvents, GaCategories, GaActions, GaLabels, GaEvents, ValueToLogTypes };
